import * as React from 'react';
import cn from 'classnames';
export var TextBlock = function TextBlock(props) {
  return React.createElement("div", {
    className: cn('text-block', props.className),
    style: props.style,
    children: props.children
  });
};
TextBlock.defaultProps = {};